(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', './Tooltip', './InfoTooltip'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./Tooltip'), require('./InfoTooltip'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.Tooltip, global.InfoTooltip);
    global.index = mod.exports;
  }
})(this, function (exports, _Tooltip, _InfoTooltip) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Tooltip = exports.InfoTooltip = undefined;

  var _Tooltip2 = _interopRequireDefault(_Tooltip);

  var _InfoTooltip2 = _interopRequireDefault(_InfoTooltip);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.InfoTooltip = _InfoTooltip2.default;
  exports.Tooltip = _Tooltip2.default;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/Tooltip/index.js
// module id = 880
// module chunks = 1